<template>
  <!-- 登录页面 -->
  <div class="login">
    <div class="login-content x-flex x-row-right">
      <!-- 登录框 -->
      <div class="login-content-form">
        <div class="x-flex x-row-around  x-p-t-20 x-p-b-10 ">
          <div class="  login-way " :class="active == '0' ? 'active' : ''" @click='active = "0"; canLogin = false'>
            密码登录</div>
          <div class=" login-way" :class="active == '1' ? 'active' : ''" @click='active = "1"; canLogin = false'>验证码登录</div>
        </div>
        <div class="x-p-t-20">
          <el-input v-model="mchId" placeholder="请输入手机号"></el-input>
        </div>

        <!-- <div class="x-p-t-30">
          <el-input v-model="userId" placeholder="请输入账号"></el-input>
        </div> -->
        <div class="x-p-t-30 x-p-b-20" v-if='active == "0"'>
          <el-input v-model="userPsw" placeholder="请输入密码" type="password" :show-password='true'></el-input>
        </div>
        <div class="x-flex x-p-t-30 x-p-b-20 0" v-else>
          <el-input v-model="yzm" placeholder="验证码">
            <template slot="append">
              <div style=" color:#FFFFFF;" @click="sendEmail">
                <span v-show="showTime">获取验证码</span>
                <span v-show="!showTime">{{ sendTime }}秒</span>
              </div>
            </template>
          </el-input>
        </div>
        <!-- 图形验证码 -->
        <div class="x-flex x-p-t-10 x-p-b-10">
          <Slider v-if="update" @onSuccess='fRegSucess'></Slider>
        </div>
        <!-- <div class="x-flex x-p-t-10" v-if='active=="0"'>

          <Slider @onSuccess='fRegSucess'></Slider>
        </div> -->
        <div class="x-p-t-40">
          <el-button style="background-color: #5673FD; color: #FFFFFF;" class="x-w100p" size="medium"
            @click.native='fOrgUserLogin'>登录</el-button>
        </div>
      </div>
    </div>
    <el-dialog :title="active == '1' ? '请输入密码' : '请输入验证码'" :visible.sync="centerDialogVisible" width="400px" center>
      <span>手机号：{{ mchId }}</span>
      <div class="x-p-t-30" v-if='active == "1"'>
        <el-input v-model="userPsw" placeholder="请输入密码" type="password" :show-password='true'></el-input>
      </div>
      <div class="x-flex x-p-t-30" v-else>
        <el-input v-model="yzm" placeholder="验证码">
          <template slot="append">
            </el-button>
            <div style=" color:#FFFFFF;" @click="sendEmail">
              <span v-show="showTime">获取验证码</span>
              <span v-show="!showTime">{{ sendTime }}秒</span>
            </div>
          </template>
        </el-input>
      </div>
      <span slot="footer" class="x-flex">
        <el-button style="background-color: #FFFFFF;" class="x-w100p" size="" @click="centerDialogVisible = false">取 消
        </el-button>
        <el-button style="background-color: #5673FD; color: #FFFFFF;" class="x-w100p" size="" @click.native='fPop'>确认
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Slider from '../components/slider.vue';
import md5 from 'js-md5'
import eventBus from '../assets/js/bus.js'
export default {
  components: {
    Slider
  },
  data() {
    return {
      //图形验证码
      //滑块验证通过
      update: true,
      canLogin: false,
      centerDialogVisible: false,
      popTitle: '请输入验证码',
      active: '0',
      mchId: '',
      userId: '',
      yzm: '',
      zqYzm: '', //正确验证码
      userPsw: '',
      getPsw: '', //正确密码
      showTime: true,
      sendTime: '',
    }
  },
  created() {
    // this.$message.error("您的账号已在其他地方登录");
    console.log(this.bykApi.timeHelper.fGetNowTime(1, 'YYYYMMDD').slice(0, 4))
    console.log(this.bykApi.timeHelper.manyDaysAgo(7, 3).replace("-", "").replace("-",
      ""))
    console.log(this.bykApi.timeHelper.fGetNowTime(1, 'YYYYMMDD'))


    let objByPayAdmin = this.bykApi.global.fGetByPayAdmin()
    if (objByPayAdmin) {
      this.mchId = objByPayAdmin.orgUserInfo.userId
      this.userId = objByPayAdmin.orgUserInfo.userId
    }

  },
  watch: {
    active(newVal) {
      // 移除组件
      this.update = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.update = true
      })
    }
  },
  methods: {
    fRegSucess() {
      this.canLogin = true
      // if(this.active == '0'){
      //   this.fOrgUserLogin()
      // }
    },
    //发送验证码
    // 点击发送短信触发函数
    async sendEmail() {
      console.log(1)
      // 手机号格式校验
      let phone = this.mchId.replace(/\s/g, ""); //去除空格
      let regs = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      let result = regs.test(phone)
      if (!result) {
        return this.$message.error("请输入正确的手机号");
      }
      //是否通过滑动验证
      if (!this.canLogin) {
        this.$message.error("请拖动滑块验证");
        return false;
      }
      // if (this.checked != true) {
      //    return this.$message.error("请同意并勾选隐私政策");
      // }
      const TIME_COUNT = 60; //  更改倒计时时间
      if (!this.timer) {
        this.sendTime = TIME_COUNT;
        // //发送短信函数
        let res = await this.fGetUserPsw()
        if (res.result != 'sucess') {
          return this.$message.error(res.msg);
        }
        this.zqYzm = res.sms_code
        this.getPsw = res.org_user_psw
        this.showTime = false;
        this.timer = setInterval(() => {
          if (this.sendTime > 0 && this.sendTime <= TIME_COUNT) {
            this.sendTime--;
          } else {
            this.showTime = true;
            clearInterval(this.timer); // 清除定时器
            this.timer = null;
          }
        }, 1000);
      }
    },



    //登录
    async fOrgUserLogin() {


      // let reqJson = {}
      // reqJson.API_NAME = 'smPayAdminApi'
      // reqJson.METHOD_NAME = 'ENCRY_TABLE_FIELD_VALUE'
      // reqJson.OPER= 'ENCRY'
      // reqJson.TABLE_NAME = "smPay.dbo.mch_store_info"
      // reqJson.TABLE_FIELD = "legal_person_no"
      // let res12312 = await this.bykApi.postApi.fPostToSmPayAdminApi(reqJson)
      // console.log(res12312)
      // return

      // console.log(md5("158216356585658"))
      // return
      if (this.bykApi.smCom.fSmIsEmpty(this.mchId)) {
        this.$message.error("请输入手机号");
        return false;
      }
      // if (this.bykApi.smCom.fSmIsEmpty(this.userId)) {
      //   this.$message.error("请输入账号");
      //   return false;
      // }
      if (this.active == '0') {
        if (this.bykApi.smCom.fSmIsEmpty(this.userPsw)) {
          this.$message.error("请输入密码");
          return false;
        }
        if (!this.canLogin) {
          this.$message.error("请拖动滑块验证");
          return false;
        }
      } else {
        //验证验证码
        if (this.bykApi.smCom.fSmIsEmpty(this.yzm)) {
          return this.$message.error("请输入验证码");
        }
        if (this.yzm != this.zqYzm) {
          return this.$message.error("短信验证码不正确");
        }
        if (!this.canLogin) {
          this.$message.error("请拖动滑块验证");
          return false;
        }

      }
      let res = await this.fOrgUserLoginApi()
      if (res.result != 'sucess') {
        this.canLogin = false
        // 移除组件
        this.update = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true
        })
        return this.$message.error(res.msg);
      }

      let newRes = null;
      // 只有当apiVer == '2'时才调用新接口
      if (this.bykApi.global.smPayAdmin.sys.apiVer == '2') {
        newRes = await this.fOrgUserLoginNewApi()

        if (newRes.result != 'sucess') {
          this.canLogin = false
          // 移除组件
          this.update = false
          // 在组件移除后，重新渲染组件
          // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
          this.$nextTick(() => {
            this.update = true
          })
          return this.$message.error(newRes.msg);
        }
      }

      // console.log(res)
      //缓存手机号 账号到本地
      let objByPayAdmin = this.bykApi.global.fGetByPayAdmin()
      objByPayAdmin.orgUserInfo.userId = res.org_user_info[0].user_id || ''
      objByPayAdmin.orgUserInfo.userName = res.org_user_info[0].user_name || ''
      objByPayAdmin.orgUserInfo.commissionValue = res.org_user_info[0].commission_value || ''
      objByPayAdmin.orgUserInfo.commissionMethod = res.org_user_info[0].commission_method || ''
      objByPayAdmin.orgUserInfo.token = res.token || ''

      //20260108使用新接口，只有当apiVer == '2'时才设置mainToken
      if (this.bykApi.global.smPayAdmin.sys.apiVer == '2' && newRes) {
        objByPayAdmin.orgUserInfo.mainToken = newRes.token || ''
        console.log(newRes.token)
      }

      objByPayAdmin.orgUserInfo.mchAlipayCommissionRate = res.org_user_info[0].mch_alipay_commission_rate || ''
      objByPayAdmin.orgUserInfo.mchDebitcardCommissionRate = res.org_user_info[0].mch_debitcard_commission_rate ||
        ''
      objByPayAdmin.orgUserInfo.mchDebitcardMaxCommissionRate = res.org_user_info[0]
        .mch_debitcard_max_commission_rate || ''
      objByPayAdmin.orgUserInfo.mchLdebitcardCommissionRate = res.org_user_info[0].mch_ldebitcard_commission_rate ||
        ''
      objByPayAdmin.orgUserInfo.mchSubCommissionRate = res.org_user_info[0].mch_sub_commission_rate || ''
      objByPayAdmin.orgUserInfo.mchUnionpayCommissionRate = res.org_user_info[0].mch_unionpay_commission_rate || ''
      objByPayAdmin.orgUserInfo.mchWechatCommissionRate = res.org_user_info[0].mch_wechat_commission_rate || ''
      objByPayAdmin.orgUserInfo.login_only = res.org_user_info[0].login_only || 'N'


      objByPayAdmin.orgInfo.orgId = res.org_info[0].org_id || ''
      objByPayAdmin.orgInfo.smpay_name = res.org_info[0].smpay_name
      objByPayAdmin.orgInfo.call_back_url = res.org_info[0].call_back_url
      objByPayAdmin.orgInfo.can_incom_yn = res.org_info[0].can_incom_yn
      objByPayAdmin.orgInfo.smpay_id = res.org_info[0].smpay_id
      objByPayAdmin.orgInfo.compName = res.org_info[0].comp_name || ''
      objByPayAdmin.orgInfo.pOrgId = res.org_info[0].p_org_id || ''
      objByPayAdmin.orgInfo.alipayCommissionRate = res.org_info[0].alipay_commission_rate || ''
      objByPayAdmin.orgInfo.debitcardCommissionRate = res.org_info[0].debitcard_commission_rate || ''
      objByPayAdmin.orgInfo.debitcardMaxCommissionRate = res.org_info[0].debitcard_max_commission_rate || ''
      objByPayAdmin.orgInfo.ldebitcardCommissionRate = res.org_info[0].ldebitcard_commission_rate || ''
      objByPayAdmin.orgInfo.subCommissionRate = res.org_info[0].sub_commission_rate || ''
      objByPayAdmin.orgInfo.unionpayCommissionRate = res.org_info[0].unionpay_commission_rate || ''
      objByPayAdmin.orgInfo.wechatCommissionRate = res.org_info[0].wechat_commission_rate || ''

      objByPayAdmin.user_auth_info = res.user_auth_info

      this.bykApi.global.fSetByPayAdmin(objByPayAdmin)
      //同步全局缓存变量 byPayAdmin
      this.bykApi.global.byPayAdmin = this.bykApi.global.fGetByPayAdmin()
      //获取用户密码 用于通过路由守卫
      // sessionStorage.setItem('userPsw', this.userPsw)

      //判断是否拥有 设备管理  团队管理 下级代理 下级机构 如果有 返回false 并弹窗
      // let qxName = ["设备管理", "团队管理", "下级代理", "下级机构"]
      // if (this.fPopSmsYn("设备管理") && this.fPopSmsYn("团队管理") && this.fPopSmsYn("下级代理") && this.fPopSmsYn("下级机构")) {
      //   objByPayAdmin.orgInfo.userPsw = this.active == '0'?this.userPsw:''
      //   this.bykApi.global.fSetByPayAdmin(objByPayAdmin)
      this.$router.push('/sy/sy')
      // }else{
      //   this.centerDialogVisible = true
      // }

    },
    //判断权限
    fPopSmsYn(name) {
      let idx = this.bykApi.global.fGetByPayAdmin().user_auth_info.findIndex(item => {
        return item.auth_name == name
      })
      if (idx != -1) {
        this.centerDialogVisible = true
        return false
      }
      return true

    },
    //弹框信息确认
    fPop() {
      if (this.active == '0' && this.yzm != this.zqYzm) {
        return this.$message.error("验证码不正确");
      }
      if (this.active == '1' && md5(this.mchId + this.userPsw) != this.getPsw) {
        return this.$message.error("密码不正确");
      }
      let objByPayAdmin = this.bykApi.global.fGetByPayAdmin()
      objByPayAdmin.orgInfo.userPsw = this.userPsw
      this.bykApi.global.fSetByPayAdmin(objByPayAdmin)

      this.$router.push('/sy/sy')
    },
    // =============请求方法开始=============

    //改为新接口 20260104
    async fOrgUserLoginNewApi() {
      let reqJson = {}
      reqJson.API_NAME = 'smPayAdminApi'
      reqJson.METHOD_NAME = 'ORG_USER_LOGIN'
      reqJson.API_USER_ID = this.mchId
      reqJson.USER_ID = this.mchId
      if (this.active == '0') {
        reqJson.USER_PSW = md5(this.mchId + this.userPsw) //this.userPsw
      } else {
        reqJson.USER_PSW = this.getPsw //this.getPsw
      }
      // reqJson.USER_PSW = this.userPsw
      console.log(reqJson)
      let res = await this.bykApi.smPayMainApi.fSmPayAdminApi({
        methodName: 'ORG_USER_LOGIN',
        js: reqJson,
        mchId: this.mchId,
        userId: this.mchId,

      })
      return res
    },

    async fOrgUserLoginApi() {
      let reqJson = {}
      reqJson.API_NAME = 'smPayAdminApi'
      reqJson.METHOD_NAME = 'ORG_USER_LOGIN'
      reqJson.API_USER_ID = this.mchId
      reqJson.USER_ID = this.mchId
      if (this.active == '0') {
        reqJson.USER_PSW = md5(this.mchId + this.userPsw) //this.userPsw
      } else {
        reqJson.USER_PSW = this.getPsw //this.getPsw
      }
      // reqJson.USER_PSW = this.userPsw
      console.log(reqJson)
      let res = await this.bykApi.postApi.fPostToSmPayAdminApi(reqJson)

      return res.data
    },
    //获取验证码
    async fGetUserPsw() {
      let reqJson = {}
      reqJson.API_NAME = 'smPayAdminApi'
      reqJson.METHOD_NAME = 'GET_ORG_USER_PSW'
      // reqJson.API_USER_PHONE = this.mchId
      reqJson.API_USER_ID = this.mchId
      reqJson.USER_ID = this.mchId
      reqJson.STORE_ID = '10001'
      reqJson.USER_ID = this.mchId
      let res = await this.bykApi.postApi.fPostToSmPayAdminApi(reqJson)
      // console.log(res)
      return res.data

    },

    // =============请求方法结束=============


  },

}
</script>

<style lang="less" scoped="scoped">
.login {
  background: url(../assets/img/login-bg.png) no-repeat;
  background-size: cover;
  height: 100vh;
  width: 100%;

  .login-content {
    margin: 0 auto;
    width: 70%;
    height: 100%;

    // background-color: rgba(0,0,0,0.2);
    .login-content-form {
      // width: 38%;
      width: 360px;
      // max-width: 360px;
      // height: 57%;
      height: 440px;
      background-color: #FFFFFF;
      border-radius: 4px;
      padding: 40px;

      .active {
        border-bottom: 2px solid #5673FD;
      }

      .login-way {
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        padding-bottom: 10px;
      }
    }
  }

  /deep/.el-input-group__append {
    background-color: unset;
    padding: 0 8px;
    min-width: 78px;
    text-align: center;
    border: 1px solid #5673FD;
    // border-left: unset;
    font-size: 12px;
    background-color: #5673FD;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue